<div #headerContainer>
  <ng-container *ngFor="let col of columnVMs; trackBy: trackByColumnViewModelId">
    <div
      *ngIf="col?.columnType === Types.SectionColumnProductInfoType.ProductTitle"
      class="expanded-product-section-title"
      [style.background-color]="
        (menu | productMenuBasicMethod: 'getShowSectionHeaderColorAsIcon')
          ? null
          : section?.metadata?.productsHeaderBackgroundColor
      "
      [style.color]="
        ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
          ? (section | textColorBasedOnSectionHeaderBackgroundColor)
          : (menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section)
      ">
      <div class="expanded-product-section-title-text">
        {{ menu | productMenuBasicMethod: 'getSectionTitle' : section }}
      </div>
    </div>
  </ng-container>
</div>
